import DemoPage from './pages/demo.svelte'

var routes = [
  {
    path: '/',
    component: DemoPage
  }
];

export default routes;